module.exports = "/resources/assets/prod/2b7f948a884883d980505b72ccacc2f6.jpg";